import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {FormDefinitionFieldSummaryModel} from '../formDefinitionFieldSummary.model';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';

@Injectable()
export class FormDefinitionFieldSummaryConverter extends HttpModelConverter<FormDefinitionFieldSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): FormDefinitionFieldSummaryModel {
        return new FormDefinitionFieldSummaryModel();
    }

    protected enrichObject(result: FormDefinitionFieldSummaryModel, src: FormDefinitionFieldSummaryModel) {
        result.context = this.lovValueSummaryConverter.convert(src.context);
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.subType = this.lovValueSummaryConverter.convert(src.subType);
    }
}
